import React, { Fragment } from 'react';
import { X } from '@finect/tabular-icons/x';
import { TextButton } from '@finect/tabular-core/TextButton';
import { ChevronLeft } from '@finect/tabular-icons/chevronLeft';
import { Datalayer } from '@finect/front-gtm';
import { HeaderBlock, BodyBlock, CloseModal } from './partials';
import { Article } from './components';
export var HelpArticle = function HelpArticle(_ref) {
  var article = _ref.article,
    onClose = _ref.onClose,
    onBack = _ref.onBack;
  return React.createElement(Fragment, null, React.createElement(Datalayer, {
    id: "Impression",
    type: "fiEvent",
    params: {
      category: 'Interaction',
      action: 'help-article-impression',
      label: article.title
    }
  }), React.createElement(HeaderBlock, null, React.createElement(TextButton, {
    inline: true,
    secondary: true,
    onClick: onBack
  }, React.createElement(ChevronLeft, null), "Volver"), React.createElement(CloseModal, {
    onClick: onClose
  }, React.createElement(X, null))), React.createElement(BodyBlock, null, React.createElement(Article, {
    article: article
  })));
};